export default __webpack_public_path__ + "static/media/Experience Selector.578b0e9f.svg";